import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { BusinessSettings } from '@/types/settings';
import { useHasAnyPermission } from '@/hooks/usePermissions';

interface UseBusinessSettingsOptions {
  enabled?: boolean;
}

/**
 * Per-tenant scheduling defaults — distinct from `/settings/company`. These
 * back the slot engine: business hours, lead time, buffer minutes, and (NEW
 * in Round 4) the travel-time-aware scheduling toggle.
 */
export function useBusinessSettings(options: UseBusinessSettingsOptions = {}) {
  const canViewBusinessSettings = useHasAnyPermission('company:view', 'calendar:view');
  const query = useApiQuery<BusinessSettings>({
    queryKey: settingsKeys.businessSettings(),
    queryFn: () => apiGet<BusinessSettings>(operationsClient, settingsEndpoints.businessSettings()),
    enabled: canViewBusinessSettings && (options.enabled ?? true),
    showErrorToast: false,
  });
  return canViewBusinessSettings ? query : { ...query, data: undefined };
}
